import React from 'react'
import { Button, Paper, Typography } from '@material-ui/core'
import { useStyles } from '../styles'


const EventBar = ({
  onShowForm,
  onEditList,
}) => {
  const classes = useStyles()

  return <Paper className={classes.paper}>
    <Button onClick={onShowForm} className={classes.addEventBtn} variant='outlined'>
      <Typography>Nueva isla</Typography>
    </Button>
    {/*  <Button onClick={onEditList} className={classes.addEventBtn} variant='outlined'>
      <Typography>Ordenar islas</Typography>
    </Button> */}
  </Paper>
}

export default EventBar